if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

         this.quantityInput = this.querySelector('.quantity input');
        if (this.quantityInput) {
            this.quantityInput = this.quantityInput.closest('.quantity');
        }
        
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        const loader = document.querySelector('.loader_bg');
        loader.style.display = 'block';
        if (!localStorage.getItem("GOOGLE_LOCATION")) {
          //alert("asdas");
          let sideBox = document.querySelector(".side-container .side-box");
            if (sideBox) {
              sideBox.classList.add("open-side");
            }
        }
        
        if (this.quantityInput) {
        this.quantityInput.style.display = 'flex';
        const inputQty = this.quantityInput.querySelector('.quantity__input');
        const plusButton = this.quantityInput.querySelector('[name="plus"]');
        const inventory = parseInt(this.submitButton.dataset.inventory, 10);
        const currentQty = parseInt(inputQty.value, 10);
         inputQty.value = 1;
          if (inventory === 1) {
            plusButton.classList.add('disabled');
            plusButton.disabled = true;
          } else {
            plusButton.classList.remove('disabled');
            plusButton.disabled = false;
          }
          console.log(this.submitButton);
        this.submitButton.style.display = 'none';
        }
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const cartPage = document.querySelector('.cart');
              const cartTotal = document.querySelector('#netpayableamounttotal');
              
              if(cartPage){
                console.log("hell");
                if (cartTotal && response.final_price) {
                  const currentTotalInPaise = Math.round(
                    parseFloat(cartTotal.textContent.replace(/[^\d.-]/g, '')) * 100
                  );
                  const newTotalInPaise = currentTotalInPaise + parseInt(response.final_price);
                  const newTotalInRupees = (newTotalInPaise / 100).toFixed(2);
                  cartTotal.textContent = `₹ ${newTotalInRupees}`;
                }
                
                setTimeout(() => {
                  const container = document.querySelector('.checkout-page-cart-items');
                  if (container) {
                    const savingsBlocks = container.querySelectorAll('.checkout-category-header-price-savings');
                    let totalOriginal = 0;
                    let totalSavings = 0;
                    savingsBlocks.forEach((block, index) => {
                      const originalEl = block.querySelector('.checkout-category-header-item:not(.checkout-category-header-item-savings)');
                      const savingsEl = block.querySelector('.checkout-category-header-item-savings');
                      const original = originalEl ? parseFloat(originalEl.textContent.replace(/[^\d.-]/g, '')) : 0;
                      const savings = savingsEl ? parseFloat(savingsEl.textContent.replace(/[^\d.-]/g, '')) : 0;
                      totalOriginal += original;
                      totalSavings += savings;
                    });
                    const finalTotal = totalOriginal + totalSavings;
                    const cancelPrice = document.querySelector('.cancelled-price-max');
                    const subtotalContainer = cancelPrice?.closest('.cartSubtotal');
                    if (cancelPrice && subtotalContainer) {
                      // Update only the numbers — not DOM structure
                      cancelPrice.textContent = `₹${finalTotal.toFixed(2)}`; // compare_at_price
                      const finalPriceEl = subtotalContainer.querySelector('.order-value-final');
                      if (finalPriceEl) {
                        finalPriceEl.textContent = `₹${totalOriginal.toFixed(2)}`; // actual final price
                      } else {
                        // fallback if no separate span
                        const existingText = subtotalContainer.childNodes;
                        for (let node of existingText) {
                          if (node.nodeType === 3 && node.textContent.trim().startsWith('₹')) {
                            node.textContent = ` ₹${totalOriginal.toFixed(2)}`;
                          }
                        }
                      }
                    }

                    //console.log('newTotalInPaise ' + newTotalInPaise ' finalTotal ' + finalTotal + " cancelPrice " +cancelPrice );
                  }
                  // window.location.reload();
                }, 1500);


              }
              this.cart.renderContents(response);

              console.log('cart', response);
              fetch('/cart.js')
              .then(res => res.json())
              .then(cartData => {
                console.log('Full cart data:', cartData);
                const cartCountEl = document.querySelector('.checkout-page-header-2');
                if (cartCountEl) {
                  cartCountEl.textContent = `You have ${cartData.item_count} item${cartData.item_count === 1 ? '' : 's'} in your cart`;
                  cartCountEl.style.display = cartData.item_count > 0 ? 'inline-block' : 'none';
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            loader.style.display = 'none';
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}



